import { useQuery } from '@tanstack/react-query';

import { GetAgentsParams, getAgentsWithPagination } from '../services/unifiedAgents';

export function useGetAgentsWithPagination(params: GetAgentsParams) {
  const { instanceId, page = 1, pageSize = 20, searchQuery = '', agentType, status } = params;

  const queryConfig = getAgentsWithPagination({
    instanceId,
    page,
    pageSize,
    searchQuery,
    agentType,
    status,
  });

  return useQuery({
    queryKey: queryConfig.key,
    queryFn: queryConfig.queryFn,
    enabled: !!instanceId,
  });
}
